import * as React from "react";

function WifiNoSignal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 21.99 18.21" width="1em" height="1em" {...props}>
      <defs>
        <style>{".prefix__cls-1{fill:#b3b3b3}"}</style>
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_2-2" data-name="Layer 2">
          <path
            className="prefix__cls-1"
            d="M22 7.21A15.53 15.53 0 007.84 3l2.52 2.52A12.65 12.65 0 0120 9.21zM18 11.21a9.79 9.79 0 00-4.5-2.56l3.5 3.53zM1 1.26l3.07 3.05A15.17 15.17 0 000 7.21l2 2a12.43 12.43 0 014.2-2.77l2.23 2.24A9.68 9.68 0 004 11.21l2 2a7 7 0 014.92-2.06L18 18.21 19.25 17 2.29 0z"
          />
          <path
            className="prefix__cls-1"
            d="M8 15.21l3 3 3-3a4.24 4.24 0 00-6 0z"
          />
          <path
            fill="#fff"
            d="M17.94 18.21l1.25-1.24L2.31.03 1.02 1.24l16.92 16.97z"
          />
        </g>
      </g>
    </svg>
  );
}

const MemoWifiNoSignal = React.memo(WifiNoSignal);
export default MemoWifiNoSignal;
